'use client';

import * as React from 'react';
import { useRenderElement } from "../../utils/useRenderElement.js";
import { useCompositeRootContext } from "../root/CompositeRootContext.js";
import { useCompositeItem } from "./useCompositeItem.js";
/**
 * @internal
 */
export function CompositeItem(componentProps) {
  const {
    render,
    className,
    itemRef = null,
    metadata,
    ...elementProps
  } = componentProps;
  const {
    highlightedIndex
  } = useCompositeRootContext();
  const {
    props,
    ref,
    index
  } = useCompositeItem({
    metadata
  });
  const state = React.useMemo(() => ({
    highlighted: index === highlightedIndex
  }), [index, highlightedIndex]);
  const element = useRenderElement('div', componentProps, {
    state,
    ref: [itemRef, ref],
    props: [props, elementProps]
  });
  return element;
}